import React from 'react'

export const PurchaseAndCreateCard = ({
  legalDocumentCode,
  price,
  className,
}: {
  legalDocumentCode
  price: string
  className?: string
}) => (
  <div
    className={`${className} w-[313px] p-5 bg-white rounded-lg shadow-[-0.4000000059604645px_-0.4000000059604645px_16px_0px_rgba(39,92,141,0.12)] border border-[#e3fffb] 
        flex flex-col justify-start items-end gap-[24px]`}
  >
    <div className='flex flex-col self-stretch justify-start items-center gap-4'>
      <div className='self-stretch text-[#1c7d92] text-base lg:text-2xl font-medium lg:font-bold leading-relaxed tracking-wide'>
        Purchase and create
      </div>
      <div className='self-stretch h-[0px] border border-[#bdbddf]' />
      <div className='self-stretch text-[#001a3d] text-sm font-normal leading-tight tracking-wide'>
        Create your document with our digital drafter with step-by-step guidance
        and support.
      </div>
    </div>
    <div className='text-[#36a1ba] self-stretch justify-start items-end flex'>
      {(price || legalDocumentCode?.code) && (
        <h1 className='text-lg lg:text-2xl font-bold leading-normal tracking-wide'>
          {legalDocumentCode?.code ? (
            `${legalDocumentCode?.remaining_redeems} credit${
              legalDocumentCode?.remaining_redeems === 1 ? '' : 's'
            } remaining`
          ) : (
            <>
              {price}
              <span className='text-xs lg:text-base font-medium'>+ VAT</span>
            </>
          )}
        </h1>
      )}
    </div>
    <div
      className='px-[8px] py-[6px] bg-[#020250] rounded 
            shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)] justify-center items-center inline-flex'
    >
      <div className='text-center text-white text-xs font-medium leading-none tracking-wide'>
        Purchase
      </div>
    </div>
  </div>
)
